<template>
    <div class="history_list">
        <div v-for="(item, index) in list" :key="index">
            <div v-if="item.fromUser&&item.toUser">{{ item['createTime'] }}  {{ item.creator.nameZh }}({{ item.creator.nameEn }}) 更新为 <span style="color:#E6A23C;">{{  item.fromUser.nameZh }}</span>({{ item.fromUser.nameEn }}) {{ item['stageDesc'] }} <span style="color:#E6A23C;">{{  item.toUser.nameZh }}</span>({{ item.toUser.nameEn }})</div>
           <div v-if="!item.fromUser || !item.toUser">
            {{ item['createTime'] }} {{ item.creator.nameZh }}({{ item.creator.nameEn }}) {{ item['stageDesc'] }} {{ item['stateDesc'] }} {{ item['typeDesc'] }}
          <span v-if="item.statusDescFrom"> 从 <span style="color:#E6A23C;">{{item.statusDescFrom}}</span> 更新为 <span style="color:#E6A23C;"> {{item.statusDescTo}} </span> </span>
          <span v-else> 进入 <span style="color:#E6A23C;">{{ item['statusDescTo'] }}</span></span>
        </div>
           
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    props: {
        list: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    computed: {
        ...mapState(
            {
                users: (state) => state.devOps.ALLSELECT.TEXTUSERS,
            }
        )
    }
};
</script>
<style>
.history_list {
    max-height: 80px;
    overflow-y: auto;
    white-space: pre-wrap;
    /* background: #f1fbec; */
    scrollbar-width: thin;
    scrollbar-color: skyblue #eee;
}

.history_list::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 16px;
}

.history_list::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(45deg,
            rgba(255, 255, 255, 0.2) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0.2) 75%,
            transparent 75%,
            transparent);
}

.history_list::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
}
</style>